import { useContext } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../contexts/AppContext';
import LoadingPage from './LoadingPage';
import { SupervisorScene } from 'src/contexts/SupervisorContext';
import AuthRouter from './AuthRouter';
import StartRouter from './StartRouter';
import WhatsNewModal from '@/components/utils/WhatsNewModal';
import RoleGate from './RoleGate';
import { RoleProvider } from '@/personas/useRole';

const AuthGuard = () => {
  const { authenticated, authenticationError, retryAuthentication, goToLogin } =
    useContext(AppContext);
  const { t } = useTranslation();
  if (authenticated === 'authenticated')
    return (
      <SupervisorScene>
        <WhatsNewModal />
        <RoleProvider>
          <RoleGate>
            <AuthRouter />
          </RoleGate>
        </RoleProvider>
      </SupervisorScene>
    );
  else if (authenticated === 'loading') return <LoadingPage minHeight="100vh" />;
  else if (authenticated === 'error')
    return (
      <Stack spacing={2} sx={{ minHeight: '100vh', justifyContent: 'center', p: 3 }}>
        <Typography variant="h5">{t('authError.title')}</Typography>
        {/* 'forbidden' är numera en DEFENSIV gren: AuthApi.getUser tolkar 403 på
            autentiseringsproben som utloggad och kastar den inte vidare, så den
            vanliga vägen hit är 5xx/nätverk. Grenen står kvar för ett 403 som
            backenden skulle kunna börja skicka av något annat skäl — då är rätt
            text bättre än fel text, och knapparna nedan gäller ändå. */}
        <Alert severity="error">
          {t(authenticationError === 'forbidden' ? 'authError.forbidden' : 'authError.unavailable')}
        </Alert>
        <Button variant="contained" onClick={retryAuthentication}>
          {t('authError.retry')}
        </Button>
        {/* Felskärmen måste ALLTID ha en väg vidare till inloggningen. "Försök igen"
            räcker bara när felet är övergående; är sessionen slut leder den till
            samma skärm igen, och användaren står kvar utan utväg. Knappen syns i
            ALLA felfall (även 503/nätverk) — den enda kostnaden för den som bara
            råkat ut för ett tillfälligt avbrott är ett extra inloggningsklick. */}
        <Button variant="outlined" onClick={goToLogin}>
          {t('Login')}
        </Button>
      </Stack>
    );
  else return <StartRouter />;
};

export default AuthGuard;
